import { autofill_click_log } from "./log";
import { campground_search, cgScrollToResults, send_autofill_search_and_handle_response } from "./page-scripts/index_scripts";
import { getSearchSuggestions } from "./util/autofill_scripts";
import { loadingIcon } from "./util/mustache_templates";
import { reverseGeocode } from "./util/user_api";

if (window.location.pathname === "/campgrounds") {
  $(document).on("click", "[exampleSearch]", function() {
    $("#search_query").val($(this).html());
    $("#submit_search_query").trigger("click");
  });

  $(document).on("click", "#search_query", ()=>{
      let query:string | null;
      let queryEl: HTMLElement | null = document.getElementById('search_query');
      if (queryEl instanceof HTMLInputElement) {
      query = queryEl.value;
      };
      if (query.length < 1 || $('#search_query').val() == '') {
        //checking if input box is empty
        $(".autofillOuterWrap").addClass("d-none");
        $("#autofill_results").html("No Results");
        if(!($('.autofillOuterWrap').is(':visible'))){
            $("#baseSuggestions").removeClass("d-none");
        }
        return;
      }else{
        $(".autofillOuterWrap").removeClass("d-none");
        $("#baseSuggestions").addClass("d-none");
      };
  });
  $("#search_query").blur(function(){
    $("#baseSuggestions").addClass("d-none");
  });
  $(document).on("input", "#search_query", function(){
    var inputValue = $(this).val();
    var selectionStart = this.selectionStart;
    var selectionEnd = this.selectionEnd;
    if (inputValue.toString().length === 0 && selectionStart === 0 && selectionEnd === inputValue.toString().length) {
      $(".autofillOuterWrap").addClass("d-none");
      $("#autofill_results").html("No Results");
      if(!($('.autofillOuterWrap').is(':visible'))){
        $("#baseSuggestions").removeClass("d-none");
      }
    }
  });

  let typingTimer: ReturnType<typeof setTimeout>;
	const doneTypingInterval = 250;
  $(document).on("keyup", "#search_query", (event: JQuery.KeyUpEvent<any, any, any, any>)=>{
    
    console.log("HERE",event.key)
    if (event.key == "Enter") {
      campground_search();
      cgScrollToResults();
    } else if(event.key == "Backspace"){
      $("#search_query").removeAttr("query_type");
      $("#search_query").removeAttr("query_val");
      if($('#search_query').val() == '' || $('#search_query').val().toString().length == 1){
        $(".autofillOuterWrap").addClass("d-none");
        $("#autofill_results").html("No Results");
        if(!($('.autofillOuterWrap').is(':visible'))){
          $("#baseSuggestions").removeClass("d-none");
        }
      }
    } else {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(function() {
        let query:string | null;
        let queryEl: HTMLElement | null = document.getElementById('search_query');
        $("#search_query").removeAttr("query_type");
        $("#search_query").removeAttr("query_val");
        if (queryEl instanceof HTMLInputElement) {
          query = queryEl.value;
        };
        if (query.length < 1 || $('#search_query').val() == '') {
          //checking if input box is empty
          $(".autofillOuterWrap").addClass("d-none");
          $("#autofill_results").html("No Results");
          if(!($('.autofillOuterWrap').is(':visible'))){
            $("#baseSuggestions").removeClass("d-none");
          }
          return;
        }else{
          $(".autofillOuterWrap").removeClass("d-none");

          $("#baseSuggestions").addClass("d-none");
        };
        getSearchSuggestions(query).then((response) =>{
          if (response.trim().length == 0 ) {
            $("#autofill_results").html("No Results")
          } else {
            $("#autofill_results").html(response.trim());
          };
        }).catch((e) => {
          const err = new Error(JSON.stringify(e));
          $("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
          $("#errorModal").modal("show");
        });
      }.bind(this),doneTypingInterval);
    }
  });
  $("#submit_search_query").on("click", function(event){
    campground_search();
    // send_cg_search();
    cgScrollToResults();
  });

  $(document).on("click",".search-suggestion",(event: { currentTarget: any; }) => {

    let element = $(event.currentTarget);

    let query:string = element.attr("query_str");
    let query_type:string = element.attr("query_type");
    let query_val:string = element.attr("query_val");
    // $("#camp_search_loading").html(loadingIcon);

    autofill_click_log(query_type,query_val);

    $("#search_query").val(query);
    $("#search_query").attr("query_type",query_type);
    $("#search_query").attr("query_val",query_val);

    $('#sidefilters').removeClass('d-none');
	  $("#sortBy_cgSearchWrapper").removeClass("d-none");

    send_autofill_search_and_handle_response(query_type,query_val);
  });

  $(document).on("click", "#getLocation", ()=> {
		if (!navigator.geolocation) {
			console.error(`Your browser doesn't support Geolocation`);
		}else{
      $("#campsMarketingBS").addClass("d-none");
      $("#camp_search_loading").html(loadingIcon);
			navigator.geolocation.getCurrentPosition((position)=>{
				reverseGeocode(position.coords.latitude, position.coords.longitude).then((address: any) => {
					$('#search_query').val(address);
          send_autofill_search_and_handle_response("poi",(position.coords.latitude.toString() + "," + position.coords.longitude.toString()))
				}).catch(e => {
          $("#campsMarketingBS").removeClass("d-none");
          $("#camp_search_loading").html("");
					const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
					$("#errorModal").modal("show");
				});
			}), ()=>{
				console.error(`Failed to get Geolocation`);
			};
		}
	});

  // $(document).on('click','.filterBtn', () => {cgSearch_newFilters()});

  // $(document).on("click", "#campReportTypeBtn", function(event: Event) {
  //   event.preventDefault();

  //   if ($(".modal-backdrop").length > 1) {
  //     $(".modal-backdrop").remove();
  //   };

  //   $("#reportCampWrapper").html($("#campReportTypeModal").html())
  //   $("#reportCampWrapper").modal("show");
  // });

  // $(document).on("click","#reportClosedDupeBtn", function(event: Event) {
  //   event.preventDefault();

  //   if ($(".modal-backdrop").filter(":visible").length > 1) {
  //     $(".modal-backdrop").not(":first").remove();
  //   };

  //   $("#reportCampWrapper").html($("#campReportClosedDupeModal").html());
  //   $("#reportCampWrapper").modal("show");
  // });

  // $(document).on("click","#reportTempClosedModalBtn", function(event:Event) {
  //   event.preventDefault();
  //   if ($(".modal-backdrop").filter(":visible").length > 1) {
  //     $(".modal-backdrop").not(":first").remove();
  //   };
  //   $("#reportCampWrapper").html($("#reportTempClosedModal").html());
  //   $("#reportCampWrapper").modal("show");
  // });

  // $(document).on("click","#campReportBadDataButton", function(event:Event) {
  //   event.preventDefault();
  //   if ($(".modal-backdrop").filter(":visible").length > 1) {
  //     $(".modal-backdrop").not(":first").remove();
  //   };

  //   $("#reportCampWrapper").html($("#campReportBadData").html());
  //   $("#reportCampWrapper").modal("show");
  // });

  // $(document).on("click","#campReportNewLocationBtn", function(event:Event) {
  //   event.preventDefault();
  //   if ($(".modal-backdrop").filter(":visible").length > 1) {
  //     $(".modal-backdrop").not(":first").remove();
  //   };
  //   $("#reportCampWrapper").html($("#campReportNewLocationModal").html());
  // });


  // //Get potential dupes (within 5 miles) by levenshtein distance of camp name
  // $(document).on("click","#reportDupeBtn", function() {
  //   let campID:string = $(this).attr("campID")
  //   let camp_name:string = $(this).attr("camp_name");
  //   let camp_lat:string = $(this).attr("camp_lat");
  //   let camp_lon:string = $(this).attr("camp_lon");

  //   $("#reportCampWrapper").modal();

  //   send_getPotentialDupes(campID,camp_name,camp_lat,camp_lon).then((response) => {
  //     $("#campReportClosedDupeModal").modal("hide");
  //     $("#reportCampWrapper").html(response);
  //     $("#reportCampWrapper").modal("show");
  //   }).catch(e => {
  //     const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
  //     $("#errorModal").modal("show");
  //   });
  // });

  // //Handle duplicate select submission and render "thank you for report" modal
  // $(document).on("submit", "#selectDupeForm", function(event:Event) {

  //   //prevent page reload on form submission
  //   event.preventDefault()

  //   let selectedEl:JQuery<HTMLElement> = $("input[name='potential_dupe']:checked");
  //   let dupe_campID:string = selectedEl.attr("dupe_campID").toString();
  //   let correct_campID:string = selectedEl.val().toString();

  //   $("#reportCampWrapper").modal("hide");

  //   send_reportDupeCamps(dupe_campID,correct_campID,false).then((response) => {
  //     if ($(".modal-backdrop").length) {
  //       $(".modal-backdrop").remove();
  //     };
  //     $("#campReportThanks").modal("show");
  //   }).catch(e => {
  //     const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
  //     $("#errorModal").modal("show");
  //   });

  // });

  // //If we could not find a potential duplicate, allow user to enter camp name
  // $(document).on("submit", "#inputDupeForm", function(event:Event) {

  //   //prevent page reload on form submission
  //   event.preventDefault();

  //   let selectedEl:JQuery<HTMLElement> = $("#dupe_name");
  //   if (selectedEl.attr("dupe_campID")) {
  //     let dupe_campID:string = selectedEl.attr("dupe_campID").toString();
  //     let correct_name:string = selectedEl.val().toString();

  //     $("#reportCampWrapper").modal("hide");

  //     send_reportDupeCamps(dupe_campID,correct_name,true).then((response) => {
  //       if ($(".modal-backdrop").length) {
  //         $(".modal-backdrop").remove();
  //       };
  //       $("#campReportThanks").modal("show");
  //     }).catch(e => {
  //       const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
  //       $("#errorModal").modal("show");
  //     });
  //   };
  // });

  // //Report permanently closed
  // $(document).on("click", "#reportPermClosed", function() {
  //   let campID:string = $(this).attr("campID").toString();

  //   $("#campReportClosedDupeModal").modal("hide");

  //   send_reportPermClosed(campID).then((response) => {
  //     if ($(".modal-backdrop").length) {
  //       $(".modal-backdrop").remove();
  //     };
  //     $("#campReportThanks").modal("show");
  //   }).catch(e => {
  //     const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
  //     $("#errorModal").modal("show");
  //   });
  // });

  // //Make sure user inputted date is in MM/DD/YYYY format before reporting

  // $(document).on("input",$("#reportCampWrapper").find("#reopenDate"),function() {
  //   if ($("#reportCampWrapper").find("#reopenDate").length) {
  //     const regex = /^\d{2}\/\d{2}\/\d{4}$/;
  //     let isValidDate:boolean = regex.test($("#reportCampWrapper").find("#reopenDate").val().toString());
  //     let noInput:boolean = (!($("#reportCampWrapper").find("#reopenDate").val().toString().length))
  //     $("#reportCampWrapper").find("#submitTempClosedBtn").prop("disabled",(!(isValidDate || noInput)));
  //   }
  // });

  // //Report campgrounds is temporarily closed, with (optional) re-open date
  // $(document).on("submit", "#submitTempClosed", function(event:Event) {
  //   event.preventDefault();

  //   let dateEl:JQuery<HTMLElement> = $("#reopenDate");
  //   let reopenDate:string|undefined;
  //   let campID:string = dateEl.attr("campID");

  //   if (dateEl.val()) {
  //     reopenDate = dateEl.val().toString();
  //   } else {
  //     reopenDate = undefined;
  //   };

  //   $("#reportTempClosedModal").modal("hide");

  //   send_reportTempClosed(campID,reopenDate).then((response) => {
  //     if ($(".modal-backdrop").length) {
  //       $(".modal-backdrop").remove();
  //     };
  //     $("#campReportThanks").modal("show");
  //   }).catch(e => {
  //     const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
  //     $("#errorModal").modal("show");
  //   });
  // });

  // //Report a new location for this Campground
  // $(document).on("submit","#reportNewLocation", function (event:Event) {

  //   //prevent page reload on form submission
  //   event.preventDefault();
  //   let newLocData: Record<string,string> = {"campID":$(this).attr("campID")};

  //   //get new location data from user input
  //   $(".data-form-input").each(function(this){
  //     if ($(this).prop("type") == "checkbox") return;
  //     if($(this).val() != $(this).attr("current_value")){
  //       newLocData[$(this).attr("id").toString()] = $(this).val().toString();
  //     };
  //   });

  //   $("#campReportNewLocationModal").modal("hide");

  //   send_reportNewLocation(newLocData).then((response) => {
  //     if ($(".modal-backdrop").length) {
  //       $(".modal-backdrop").remove();
  //     };
  //     $("#campReportThanks").modal("show");
  //   }).catch(e => {
  //     const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
  //     $("#errorModal").modal("show");
  //   });

  // });

  // //Report that this campground is not a campground
  // $(document).on("click", "#reportNotCampground", function(event:Event) {
  //   let campID:string = $(this).attr("campID").toString();
  //   event.preventDefault();

  //   $("#campReportClosedDupeModal").modal("hide");

  //   send_reportNotCampground(campID).then((response) => {
  //     if ($(".modal-backdrop").length) {
  //       $(".modal-backdrop").remove();
  //     };
  //     $("#campReportThanks").modal("show");
  //   }).catch(e => {
  //     const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
  //     $("#errorModal").modal("show");
  //   });
  // });

  // //Handle submission of incorrect data form
  // $(document).on("submit","#reportBadData", function(event:Event) {

  //   //prevent page reload on form submission
  //   event.preventDefault();
  //   let campID:string = $(this).attr("campID").toString();
  //   let newCampData: Record<string,string> = {"campID":campID};
  //   let newFeatures: Record<string,string[]> = {};
  //   let remFeatures: Record<string,string[]> = {};

  //   $("#campReportBadData").modal("hide");

  //   $(".data-form-input").each(function(this) {
  //     //only care about data that has been changed, added, or removed
  //     if ($(this).prop("type") == "checkbox") {
  //       //User said this campground has an amenity that our DB says it does not
  //       if ($(this).prop("checked") && $(this).attr("current_value").toString() == "0") {
  //         //append this feature to list of new features, or create that list if it is undefined
  //         if (newFeatures[$(this).attr("feature_type")] == undefined) {
  //           newFeatures[$(this).attr("feature_type")] = [$(this).attr("id")];
  //         } else {
  //           newFeatures[$(this).attr("feature_type")].push($(this).attr("id"));
  //         };

  //       //User said this campground does not have an amenity that our DB says it does
  //       } else if ((!($(this).prop("checked"))) && $(this).attr("current_value").toString() == "1") {
  //         if (remFeatures[$(this).attr("feature_type")] == undefined) {
  //           remFeatures[$(this).attr("feature_type")] = [$(this).attr("id")];
  //         } else {
  //           remFeatures[$(this).attr("feature_type")].push($(this).attr("id"));
  //         };
  //       };
  //     } else if (($(this).val().toString().length > 0 || $(this).attr("current_value").toString().length > 0) && ($(this).val() != $(this).attr("current_value"))) {
  //       newCampData[$(this).attr("id").toString()] = $(this).val().toString();
  //     };
  //   });

  //   send_reportBadData(newCampData,newFeatures,remFeatures).then((response)=> {
  //     if ($(".modal-backdrop").length) {
  //       $(".modal-backdrop").remove();
  //     };
  //     $("#campReportThanks").modal("show");
  //   }).catch(e => {
  //     const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
  //     $("#errorModal").modal("show");
  //   });
  // });

  // //hide all modals when user clicks off of form ('x' or "Close")
  // $(document).on("click",".feedbackCloseBtn", function() {
  //   $(".modal").each(function(this) {
  //     $(this).modal("hide");
  //   });

  //   $(".modal-backdrop").remove();
  // });
}